import React from "react";

export type ScreenContext = {
  startDate: Date;
  endDate?: Date;
};

export const ScreenContext = React.createContext<ScreenContext | undefined>(
  undefined,
);

export type ActionsScreenContextType = {
  resultId: string;
  result?: {
    id: string;
    result: string;
  };
};

export const ActionsScreenContext = React.createContext<
  ActionsScreenContextType | undefined
>(undefined);
